<template>
  <div class="c-table" ref="personalcontroltable">
    <el-table class="common-el-table-styles" ref="table" v-loading="loading" :data="data" :height="height" border stripe>
      <slot></slot>
      <template slot="empty">
        <no-data />
      </template>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'switch'">
            <i-Switch
              v-model="scope.row.enable"
              size="small"
              :loading="scope.row.optLoading"
              :true-value="1"
              :false-value="0"
              @on-change="changeActive(scope.row)"
            />
          </div>
          <div v-else-if="col.key === 'control'">
            <el-button type="text" size="small" @click="$emit('on-detail', scope.row)">执行详情</el-button>
            <el-button type="text" size="small" @click="$emit('on-edit', scope.row)">编辑任务</el-button>
            <el-button v-if="scope.row.fail && !scope.row.retry" type="text" size="small" @click="$emit('on-retry', scope.row)"
              >重试</el-button
            >
          </div>
          <span v-else-if="col.key === 'resultDesc'">
            <span v-if="scope.row.total" style="display: block"
              >操作计划{{ scope.row.total }}条，成功{{ scope.row.success }}条，失败{{ scope.row.fail }}条</span
            >
            <span v-if="scope.row.retry" style="display: block">正在重试{{ scope.row.retry }}条</span>
          </span>
          <span v-else-if="col.key === 'upTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else-if="col.key === 'triggerRules'">
            <span style="display: block" v-for="(cond, i) in scope.row[col.key]" :key="i"
              >{{ cond }}
              <p style="display: inline-block" v-if="i < scope.row[col.key].length - 2">;</p></span
            >
          </span>
          <span v-else-if="col.key === 'shutDownCondition'">
            <span style="display: block" v-for="(cond, i) in scope.row[col.key]" :key="i"
              >{{ cond }}
              <p style="display: inline-block" v-if="i < scope.row[col.key].length - 2">;</p></span
            >
          </span>
          <span v-else-if="col.key === 'status'">{{ scope.row.enable | status }}</span>
          <span v-else-if="col.key === 'consume'">
            <edit-table-column :tableData="scope.row[col.key]" @on-save="updateConsumeData"> </edit-table-column>
          </span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { timeout } from '@/common/js/utils'
import EditTableColumn from '@/components/edit-table/edit-table-column.vue'
export default {
  name: 'listtable',
  components: {
    EditTableColumn
  },
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    }
  },
  filters: {
    status(val) {
      let type
      switch (val) {
        case 0:
          type = '已暂停'
          break
        case 1:
          type = '启用中'
          break
        default:
          type = '未知'
          break
      }
      return type
    }
  },
  methods: {
    // 开关
    changeActive(row) {
      const { ruleId, enable } = row
      this.$emit('on-switch', { ruleId, status: enable })
    },
    updateConsumeData(data) {
      this.$emit('on-consume', data)
    },
    restartRule(row) {
      this.$Modal.confirm({
        title: '提示',
        content: '确定要对已经关闭的计划全部进行开启吗？',
        onOk: () => {
          this.$emit('on-restart', row)
        }
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout()
    })
  }
}
</script>
<style lang="scss" scoped>
::v-deep .vxe-cell {
  font-size: 12px;
  line-height: 12px;
  padding: 0 2px;

  i {
    display: none;
  }
}
</style>
